import { useTheme } from '@mui/material/styles';

export const useIllustrationColor = (color: string | undefined): string => {
  const theme = useTheme();

  return color ?? theme.palette.primary.main;
};
